module.exports = __webpack_public_path__ + "img/ic_logo_wechat@2x.97663d83.png";